import {
  AddProductsToPricelistModalTranslation,
  DeletePricelistTranslation,
  EditPricelistTranslation,
  ExportPricelistToExcelModalTranslation,
  ExportPricelistToPdfModalTranslation,
  IncludeNetPriceTranslation,
  ModuleTranslation,
  NetPriceTranslation,
  PricelistDetailsTranslation,
  PricelistFormTranslation,
  PricelistsTranslation,
  ProductAccessoriesTranslation,
  ProductDetailsTranslation,
  ProductImageTranslation,
  ProductPricelistTranslation,
} from './ModuleTranslation';

const pricelistForm: PricelistFormTranslation = {
      name: {
        label: 'Nom',
        placeholder: 'Saisir un nom',
        maxLengthError: 'Le nom ne peut pas dépasser {maxLength} caractères.',
        requiredError: 'Veuillez saisir un nom.',
      },
      description: {
        label: 'Description',
        placeholder: 'Saisir une brève description',
        maxLengthError: 'La description ne peut pas dépasser {maxLength} caractères.',
      },
  errors: {
    createFailed: 'La liste de prix n’a pas pu être créée. Veuillez réessayer.',
    updateFailed: 'La liste de prix n’a pas pu être enregistrée. Veuillez réessayer.',
    nameAlreadyExists: 'Une liste de prix portant ce nom existe déjà. Veuillez utiliser un autre nom.',
  },
};

const addToPricelistModal: AddProductsToPricelistModalTranslation = {
  triggerLabel: 'Ajouter à mes listes',
  closeLabel: 'Fermer',
  heading: 'Ajouter à mes listes de prix',
  itemsToAddFormat: '{count} articles seront ajoutés',
  addedToPricelistFormat: '{count} articles ajoutés à "{name}"',
  loadingLabel: 'Chargement des listes de prix',
  modeLabel: 'Ajouter les produits sélectionnés à une liste de prix existante ou à une nouvelle liste',
  modes: {
    existing: 'Ajouter à une existante',
    new: 'Créer une nouvelle',
  },
  cancelLabel: 'Annuler',
  addLabel: 'Ajouter',
  addPendingLabel: 'Ajout…',
  createLabel: 'Créer',
  createPendingLabel: 'Création…',
  selectForm: {
    label: 'Sélectionner une liste de prix',
    addFailedError: 'Les produits n’ont pas pu être ajoutés à la liste de prix. Veuillez réessayer.',
  },
  createForm: pricelistForm,
};

const netPrice: NetPriceTranslation = {
  label: 'Prix net',
  notAvailable: 'N/D',
};

const productAccessories: ProductAccessoriesTranslation = {
  basePrice: 'Prix de base',
  itemNo: 'N° article',
  name: 'Description',
  price: 'Prix',
  priceOnDemand: 'sur demande',
  netPrice,
};

const productPricelist: ProductPricelistTranslation = {
  basePrice: 'Prix de base',
  heading: 'Liste de prix',
  price: 'Prix',
  priceGroup: 'Groupe de prix',
  priceOnDemand: 'sur demande',
  netPrice,
};

const productImage: ProductImageTranslation = {
  enlargeImageFormat: "Agrandir l'image de {name}",
};

const includeNetPrice: IncludeNetPriceTranslation = {
  label: 'Inclure les prix nets',
  noAgreementsReason: 'Aucun accord revendeur n’est disponible.',
};

const exportToExcelModal: ExportPricelistToExcelModalTranslation = {
  closeLabel: 'Fermer',
  heading: 'Export Excel',
  generatingLabel: 'Veuillez patienter pendant la création du fichier.',
  readyLabel: 'Votre fichier est prêt.',
  errorLabel: 'Le fichier n’a pas pu être créé. Veuillez réessayer.',
  exportLabel: 'Exporter',
  downloadLabel: 'Télécharger',
  includeNetPrice,
};

const exportToPdfModal: ExportPricelistToPdfModalTranslation = {
  closeLabel: 'Fermer',
  heading: 'Export PDF',
  titleInputLabel: 'Titre',
  titleInputPlaceholder: 'Saisir un titre',
  titleSubmitLabel: 'Mettre à jour',
  loadingDataLabel: 'Veuillez patienter pendant le chargement des produits.',
  generatingLabel: 'Veuillez patienter pendant la création du fichier.',
  readyLabel: 'Votre fichier est prêt.',
  errorLabel: 'Le fichier n’a pas pu être créé. Veuillez réessayer.',
  downloadLabel: 'Télécharger',
  includeNetPrice,
  document: {
    coverPage: {
      heading: 'Liste de prix',
      createdAtLabel: 'Créée',
      itemsLabel: 'Articles',
    },
    productSection: {
      itemNoLabel: 'Réf.',
      detailsHeading: 'Détails du produit',
      pricelist: productPricelist,
      additionalInfoHeading: 'Informations complémentaires',
      accessories: {
        heading: 'Accessoires',
        table: productAccessories,
      },
    },
  },
};

const editPricelist: EditPricelistTranslation = {
  label: 'Modifier',
  modal: {
    closeLabel: 'Fermer',
    heading: 'Modifier la liste de prix',
    cancelLabel: 'Annuler',
    submitLabel: 'Enregistrer',
    submitPendingLabel: 'Enregistrement…',
    form: pricelistForm,
  },
};

const deletePricelist: DeletePricelistTranslation = {
  label: 'Supprimer',
  confirmationFormat: 'Voulez-vous vraiment supprimer "{name}" ? Cette action est irréversible.',
  successFormat: '"{name}" supprimée',
  modal: {
    closeLabel: 'Fermer',
    heading: 'Supprimer la liste de prix',
    cancelLabel: 'Annuler',
    confirmLabel: 'Supprimer',
    confirmPendingLabel: 'Suppression…',
    error: 'La liste de prix n’a pas pu être supprimée. Veuillez réessayer.',
  },
};

const pricelists: PricelistsTranslation = {
  pageTitleFormat: 'Listes de prix',
  pageDescriptionFormat: 'Parcourez vos listes de prix',
  tabs: {
    products: 'Produits',
    pricelists: 'Mes listes de prix',
  },
  pricelistListing: {
    searchPlaceholder: 'Rechercher',
    listsFoundLabel: 'Listes trouvées',
    loadingLabel: 'Chargement des listes de prix',
    loadingMoreLabel: 'Chargement de listes de prix supplémentaires',
    pricelistList: {
      pricelistListingEmpty: {
        message: 'Aucune liste de prix trouvée',
        createLabel: 'Créer une liste de prix',
      },
      pricelistListingItem: {
        itemsLabel: 'Articles:',
        createdAtLabel: 'Créée:',
        modifiedAtLabel: 'Dernière modification:',
        actionsLabelFormat: 'Actions pour {name}',
      },
      itemActions: {
        edit: editPricelist,
        delete: deletePricelist,
      },
    },
    createPricelistModalTriggerLabel: 'Nouvelle liste de prix',
    createPricelistModal: {
      closeLabel: 'Fermer',
      heading: 'Créer une nouvelle liste de prix',
      cancelLabel: 'Annuler',
      submitLabel: 'Créer',
      submitPendingLabel: 'Création…',
      form: pricelistForm,
    },
  },
  productListing: {
    title: 'Listes de prix',
    searchPlaceholder: 'Rechercher',
    expansionToggle: {
      label: 'Développer ou réduire toutes les familles de produits',
      options: {
        collapseAll: 'Tout réduire',
        expandAll: 'Tout développer',
      },
    },
    productsFoundLabel: 'Produits trouvés',
    filters: {
      heading: 'Filtres',
      brands: {
        label: 'Marque',
      },
      types: {
        label: 'Type',
      },
      sectors: {
        label: 'Espace',
      },
      priceRange: {
        label: 'Prix',
        range: {
          from: 'De',
          to: 'À',
        },
      },
    },
    table: {
      title: 'Produits',
      emptyText: 'Aucun produit trouvé',
      loadingLabel: 'Chargement des produits',
      loadingMoreLabel: 'Chargement de produits supplémentaires',
      selectAll: 'Sélectionner tous les produits',
      selectProduct: 'Sélectionner',
      expandFamily: 'Afficher les produits',
      collapseFamily: 'Masquer les produits',
      expandColumnLabel: 'Développer',
      itemNo: 'Réf.',
      image: 'Image',
      productImage,
      brand: 'Marque',
      model: 'Modèle',
      price: 'Prix',
      priceInfo: {
        label: 'Informations sur les prix',
        content: 'Prix de départ. Les prix varient selon les tissus et les options sélectionnés.',
      },
      fromLabel: 'à partir de',
      productsCountLabel: 'produits',
      newBadge: 'NOUVEAU',
      modelActionLabel: 'Tarifs',
      familyActionLabel: 'Info',
      actionLabel: 'Action',
    },
    selectionPanel: {
      selectedCountFormat: '{count} articles sélectionnés',
      export: 'Exporter',
      clearSelection: 'Effacer la sélection',
    },
    addToPricelistModal,
    exportToPdfModal,
    details: {
      closeLabel: 'Fermer',
      loadingLabel: 'Chargement des détails de la famille',
      specificationHeading: 'Caractéristiques',
    },
    modelDetails: {
      closeLabel: 'Fermer',
      loadingLabel: 'Chargement des tarifs',
      pricelist: {
        caption: 'Liste de prix',
        productGroup: 'GP',
        basePrice: 'Prix de base',
        price: 'Prix',
        priceOnDemand: 'sur demande',
        agreementDiscount: 'Remise selon l’accord revendeur',
        netPrice,
      },
      detailsLinkLabel: 'Accéder à la page produit pour les tarifs détaillés',
    },
  },
};

const productDetails: ProductDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Prix et accessoires pour {name}',
  backlinkLabel: 'Retour',
  downloadLabel: 'Télécharger',
  lastUpdatedLabel: 'Dernière mise à jour:',
  itemNoLabel: 'Réf.',
  addToPricelistModal,
  exportToPdfModal,
  familyDetails: {
    triggerLabel: 'Détails de la famille',
    closeLabel: 'Fermer',
    descriptionHeading: 'Description',
    featuresHeading: 'Caractéristiques',
  },
  terms: {
    triggerLabel: 'Conditions',
    closeLabel: 'Fermer',
    heading: 'Conditions générales de vente et de livraison',
    introFormat: 'Ce document s’applique aux distributeurs sous contrat de {brand}.',
    loadingLabel: 'Chargement des conditions',
  },
  closeLabel: 'Fermer',
  productDetailsHeading: 'Détails du produit',
  accessoriesHeading: 'Accessoires',
  additionalInfoHeading: 'Informations complémentaires',
  pricelist: productPricelist,
  accessories: productAccessories,
};

const pricelistDetails: PricelistDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Prix des produits de {name}',
  backlinkLabel: 'Retour',
  exportLabel: 'Excel',
  downloadLabel: 'PDF/Imprimer',
  settingsLabel: 'Paramètres',
  itemsLabel: 'Articles:',
  createdAtLabel: 'Créée:',
  modifiedAtLabel: 'Dernière modification:',
  regionLabel: 'Région',
  currencyLabel: 'Devise',
  pricesRefreshedAtLabel: 'Prix actualisés',
  currencyExcludingVatFormat: '{currency} (hors TVA)',
  searchPlaceholder: 'Rechercher',
  productsLabel: 'Produits de cette liste de prix',
  itemsFoundLabel: 'Articles',
  emptyText: 'Aucun article trouvé',
  loadingLabel: 'Chargement des articles',
  loadingMoreLabel: 'Chargement d’articles supplémentaires',
  exportToExcelModal,
  exportToPdfModal,
  product: {
    actionsLabelFormat: 'Actions pour {name}',
    pricelist: productPricelist,
    productImage,
    additionalInfoHeading: 'Informations complémentaires',
    accessories: {
      heading: 'Accessoires',
      loadingLabel: 'Chargement des accessoires',
      table: productAccessories,
    },
  },
  pricelistActions: {
    edit: editPricelist,
    delete: deletePricelist,
  },
  productActions: {
    remove: {
      label: 'Retirer',
      confirmationFormat: 'Voulez-vous vraiment retirer "{name}" de cette liste de prix ?',
      successFormat: '"{name}" retiré',
      modal: {
        closeLabel: 'Fermer',
        heading: 'Retirer le produit',
        cancelLabel: 'Annuler',
        confirmLabel: 'Retirer',
        confirmPendingLabel: 'Retrait…',
        error: 'Le produit n’a pas pu être retiré. Veuillez réessayer.',
      },
    },
  },
};

const translation: ModuleTranslation = {
  pricelistDetails,
  pricelists,
  productDetails,
};

export default translation;
